import { useQuery } from "@tanstack/react-query";
import { api, FESTIVAL_META } from "@/lib/api";
import { useParams, Link } from "react-router-dom";
import { useAuth } from "@/lib/auth.jsx";
const TABS = [
  { id: "", label: "Overall" },
  { id: "roskilde", label: "Roskilde" },
  { id: "northside", label: "NorthSide" },
  { id: "syd_for_solen", label: "Syd for Solen" },
  { id: "tinderbox", label: "Tinderbox" },
  { id: "smukfest", label: "Smukfest" },
];

export default function Leaderboard() {
  const { festivalId } = useParams();
  const { user } = useAuth();
  const active = festivalId || "";
  const { data } = useQuery({
    queryKey: ["lb", active],
    queryFn: () => (active ? api.get(`/leaderboard/festival/${active}`) : api.get("/leaderboard/overall")).then(r => r.data),
  });

  const locked = data?.locked;
  const overall = data?.entries || (Array.isArray(data) ? data : []);
  const deadline = data?.deadline;
  const meta = active ? FESTIVAL_META[active] : null;

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="label-eyebrow">Rangering</div>
      <h1 className="hero-title text-5xl sm:text-6xl mt-2">
        {active ? meta?.name : "Overall liga"}
      </h1>

      <div className="mt-8 flex gap-2 overflow-x-auto pb-2">
        {TABS.map(t => (
          <Link
            key={t.id}
            to={t.id ? `/leaderboard/${t.id}` : "/leaderboard"}
            className={`px-4 py-2 rounded-full text-sm whitespace-nowrap border ${active === t.id ? "bg-white text-black border-white" : "text-zinc-400 border-white/10 hover:text-white"}`}
            data-testid={`lb-tab-${t.id || "overall"}`}
          >
            {t.label}
          </Link>
        ))}
      </div>

      {locked ? (
        <div className="mt-12 card-flat p-12 text-center" data-testid="lb-locked">
          <div className="text-6xl mb-4">🔒</div>
          <h2 className="font-display font-bold text-2xl">Leaderboardet åbner, når deadline er passeret.</h2>
          <p className="text-zinc-400 mt-3">
            {deadline && (<>Deadline: <span className="text-white font-medium">{new Date(deadline).toLocaleString("da-DK")}</span></>)}
          </p>
          <p className="text-zinc-500 text-sm mt-2">Ingen placeringer, point eller navne afsløres før alle spilleres line-ups er låst.</p>
        </div>
      ) : (
        <div className="mt-8 card-flat overflow-hidden">
          <div className="grid grid-cols-[60px_1fr_auto] sm:grid-cols-[60px_1fr_auto_auto_auto_auto] gap-3 px-5 py-3 label-eyebrow border-b border-white/5">
            <div>#</div><div>Spiller</div>
            {active ? (<><div className="hidden sm:block text-right">HL</div><div className="hidden sm:block text-right">INT</div><div className="hidden sm:block text-right">DK</div><div className="text-right">Point</div></>) : (<div className="text-right">Point</div>)}
          </div>
          {overall?.map((e) => {
            const isMe = e.user_id === user?.user_id;
            return (
              <Link to={`/u/${e.user_id}`} key={e.user_id} className={`grid grid-cols-[60px_1fr_auto] sm:grid-cols-[60px_1fr_auto_auto_auto_auto] gap-3 px-5 py-4 items-center hover:bg-white/5 ${isMe ? "bg-white/5" : ""} border-b border-white/5`} data-testid={`lb-row-${e.position}`}>
                <div className="font-score text-2xl text-zinc-400">{["🥇","🥈","🥉"][e.position - 1] || `#${e.position}`}</div>
                <div className="flex items-center gap-3 min-w-0">
                  {e.picture ? <img src={e.picture} className="w-8 h-8 rounded-full object-cover" alt="" /> : <div className="w-8 h-8 rounded-full bg-zinc-800" />}
                  <div className="truncate">{e.display_name}{isMe && <span className="ml-2 text-xs text-orange-400">(dig)</span>}</div>
                </div>
                {active ? (<>
                  <div className="hidden sm:block text-right font-score text-xl text-zinc-400">{e.headliner_hits}</div>
                  <div className="hidden sm:block text-right font-score text-xl text-zinc-400">{e.international_hits}</div>
                  <div className="hidden sm:block text-right font-score text-xl text-zinc-400">{e.danish_hits}</div>
                  <div className="text-right font-score text-2xl">{e.points}</div>
                </>) : (<div className="text-right font-score text-2xl">{e.total}</div>)}
              </Link>
            );
          })}
          {(!overall || overall.length === 0) && <div className="p-8 text-center text-zinc-500">Ingen spillere endnu.</div>}
        </div>
      )}
    </div>
  );
}
